import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';

import { BackUrlProvider } from './contexts/back-url-context';
import { LocalizationProvider } from './contexts/localization-context';

import './index.scss';

ReactDOM.render(
  <BackUrlProvider>
    <LocalizationProvider>
      <App />
    </LocalizationProvider>
  </BackUrlProvider>,
  document.getElementById('root'),
);
